import type { FC } from 'react';
import type { HeaderProps } from './types';
import { withChildren } from '@builder.io/react';
import { useColorProvider } from '@/utils/ColorProvider';
import { cls } from '@/utils/cls';
import style from './Header.module.scss';
import RichText from '../RichText';
import Image from 'next/image';
import { hasNonEmptyRichTextField } from '@/utils/richText';
const Header: FC<HeaderProps> = ({
  extendStyles,
  copy,
  logo,
  mobileStack = true,
  mobileButton = true,
  mobileText = true,
  mobileLogo = true,
  children,
  usePageColors = true,
  backgroundColor,
  textColor,
  logoHeight = 50,
  isSticky = false,
  variant = 'Default'
}) => {
  const _className = cls(style.root, extendStyles);
  const {
    colors
  } = useColorProvider();
  const imageSrc = logo?.value?.data?.image || '/TotalInjuryHelp_logo.webp';
  const hasButton = !!children && !!children.length;
  const _backgroundColor = usePageColors ? colors.primaryAccentColor : backgroundColor;
  const _textColor = usePageColors ? 'white' : textColor;
  const noMaxWidthVariantClass = variant === 'Wide' ? style.noMaxWidth : undefined;
  const rootVariantClass = variant === 'Wide' ? style.rootWide : undefined;

  // show text if no elements are selected to avoid empty header
  const showMobileText = mobileText || !mobileButton && !mobileText && !mobileLogo;
  return <div className={cls(_className, isSticky && style.stickyBar, rootVariantClass)} style={{
    backgroundColor: _backgroundColor || '#525252',
    color: _textColor || 'white'
  }} data-sticky-header={isSticky ? 'true' : undefined} data-sentry-component="Header" data-sentry-source-file="Header.tsx">
			<div className={cls(!mobileStack ? style.wrapperRow : style.wrapper, noMaxWidthVariantClass)} data-grid>
				<Image className={mobileLogo ? style.logo : cls(style.logo, style.mobileHide)} src={imageSrc} alt={logo?.value?.data?.name || ''} width={100} height={logoHeight} role={logo?.value?.data?.name ? undefined : 'presentation'} style={{
        maxHeight: `${logoHeight}px`
      }} data-sentry-element="Image" data-sentry-source-file="Header.tsx" />
				{hasNonEmptyRichTextField(copy) && <RichText text={copy} className={showMobileText ? style.copy : cls(style.copy, style.mobileHide)} />}
				<div className={mobileButton ? style.button : cls(style.button, style.mobileHide)}>
					{' '}
					{hasButton && children}
				</div>
			</div>
		</div>;
};
export default withChildren(Header);